
import LayoutMixin from '@/mixins/layout'
import ExcePc from './components/exce-pc.vue'
import ExceMb from './components/exce-mb.vue'
import mixin from './mixins/index'
import SupportTop from '@/components/page/support-top.vue'
import SupportNav from '@/components/page/support-nav.vue'
export default {
  components: {
    ExcePc,
    ExceMb,
    SupportNav,
    SupportTop,
  },
  mixins: [LayoutMixin, mixin],
  head() {
    return {
      title:
        this.$t(`serviceSupport.querySupport.exce_rate`) +
        this.$t('navs.suffixName'),
    }
  },
}
